import { render, staticRenderFns } from "./Page_Cart.vue?vue&type=template&id=24f2ceb2&scoped=true&"
import script from "./Page_Cart.vue?vue&type=script&lang=js&"
export * from "./Page_Cart.vue?vue&type=script&lang=js&"
import style0 from "./Page_Cart.vue?vue&type=style&index=0&id=24f2ceb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f2ceb2",
  null
  
)

export default component.exports